module.exports = __webpack_public_path__ + "static/img/RebeccaWilliams.9d0a90a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RebeccaWilliams.jpg
// module id = 4xCN
// module chunks = 0